export default {
    LOAD_BRAND(state, brand) {
        state.items = brand;
    }
}